<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">My Safe Space</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_002#toc_id_3">Copyright Information ©</a></li>
<li><a href="#/index_split_003#toc_id_4">Acknowledgement</a></li>
<li><a href="#/index_split_004#id_Toc151366858">My Wish</a></li>
<li><a href="#/index_split_005#id_Toc151366859">The Undulating Field</a></li>
<li><a href="#/index_split_006#id_Toc151366860">Your Choice</a></li>
<li><span href="#/index_split_007#id_Toc151366861" title="Link target outside of Sample">Hope and Dreams</span></li>
<li><span href="#/index_split_008#id_Toc151366862" title="Link target outside of Sample">Bridges of My Life</span></li>
<li><span href="#/index_split_009#id_Toc151366863" title="Link target outside of Sample">Lost in Space</span></li>
<li><span href="#/index_split_010#id_Toc151366864" title="Link target outside of Sample">The Cross (That Saved Me)</span></li>
<li><span href="#/index_split_011#id_Toc151366865" title="Link target outside of Sample">Me</span></li>
<li><span href="#/index_split_012#id_Toc151366866" title="Link target outside of Sample">My Child</span></li>
<li><span href="#/index_split_013#id_Toc151366867" title="Link target outside of Sample">Metamorphosis</span></li>
<li><span href="#/index_split_014#id_Toc151366868" title="Link target outside of Sample">I Stand Accused</span></li>
<li><span href="#/index_split_015#id_Toc151366869" title="Link target outside of Sample">Memories</span></li>
<li><span href="#/index_split_016#id_Toc151366870" title="Link target outside of Sample">Saved (from Ruin)</span></li>
<li><span href="#/index_split_017#id_Toc151366871" title="Link target outside of Sample">Reminisce</span></li>
<li><span href="#/index_split_018#id_Toc151366872" title="Link target outside of Sample">Welcome Life</span></li>
<li><span href="#/index_split_019#id_Toc151366873" title="Link target outside of Sample">Roles</span></li>
<li><span href="#/index_split_020#id_Toc151366874" title="Link target outside of Sample">Wise Words</span></li>
<li><span href="#/index_split_021#id_Toc151366875" title="Link target outside of Sample">Thank You, Lord</span></li>
<li><span href="#/index_split_022#id_Toc151366876" title="Link target outside of Sample">You</span></li>
<li><span href="#/index_split_023#id_Toc151366877" title="Link target outside of Sample">Your Way</span></li>
<li><span href="#/index_split_024#id_Toc151366878" title="Link target outside of Sample">Prayer for Your Will</span></li>
<li><span href="#/index_split_025#id_Toc151366879" title="Link target outside of Sample">My Place</span></li>
<li><span href="#/index_split_026#id_Toc151366880" title="Link target outside of Sample">Welcome Dear Lord Jesus</span></li>
<li><span href="#/index_split_027#id_Toc151366881" title="Link target outside of Sample">Tribute to Our Heroes</span></li>
<li><span href="#/index_split_028#id_Toc151366882" title="Link target outside of Sample">Immortal</span></li>
<li><span href="#/index_split_029#id_Toc151366883" title="Link target outside of Sample">Light</span></li>
<li><span href="#/index_split_030#id_Toc151366884" title="Link target outside of Sample">When I Could Not Pray</span></li>
<li><span href="#/index_split_031#id_Toc151366885" title="Link target outside of Sample">Life</span></li>
<li><span href="#/index_split_032#id_Toc151366886" title="Link target outside of Sample">Different Views</span></li>
<li><span href="#/index_split_033#id_Toc151366887" title="Link target outside of Sample">Grace</span></li>
<li><span href="#/index_split_034#id_Toc151366888" title="Link target outside of Sample">Supplication</span></li>
<li><span href="#/index_split_035#id_Toc151366889" title="Link target outside of Sample">Proclamation</span></li>
<li><span href="#/index_split_036#id_Toc151366890" title="Link target outside of Sample">My Legacy</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2ed56051